import type { TMessages } from '@/types/TMessages'

export const messages = {
  inputs: '{formattedNumber} това{number, plural, one {р} few {ра} other {ров}}',
  outputs: '{formattedNumber} предложен{number, plural, one {ие} few {ия} other {ий}}',
  manufacturers: '{formattedNumber} производите{number, plural, one {ль} few {ля} other {лей}}',
} satisfies TMessages
